import React, { useEffect, useState } from 'react';
import { Button, Box } from '@mui/material';
import _ from 'lodash';
import { SelectBoxButton } from 'theme/elements/Buttons';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { defineds, timing } from 'constants/ui.constants';
import { format } from 'date-fns';
import DateRangePopover from 'components/DateRangePopover';

//import 'react-date-range/dist/styles.css'; // main css file
//import 'react-date-range/dist/theme/default.css'; // theme css file

export type filterDates = { startDate: Date; endDate: Date };
type selectorProps = {
  label?: string;
  handleChange?: any;
  value?: filterDates;
  handleTableState?: any;
  isNavbarSearchMode?: boolean;
  handleChangeOnClose?: boolean
};

const intialDates: filterDates = {
  startDate: defineds.startOfToday,
  endDate: defineds.endOfToday,
};

const intialDatesForNavbarSearch: filterDates = {
  startDate: defineds.startOflastYear,
  endDate: defineds.endOfToday,
};

export default function FilterDateRange(props: selectorProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [isChanged, setIsChanged] = useState(false)
  const [state, setState] = useState([
    {
      startDate: props.value?.startDate || intialDates.startDate,
      endDate: props.value?.endDate || intialDates.endDate,
      key: 'selection',
    },
  ]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (props.handleChangeOnClose && props.handleChange && isChanged) {
      let dates: filterDates = {
        startDate: state[0].startDate,
        endDate: state[0].endDate,
      };
      props.handleChange(dates);
    }
  };

  const handleChangeDatePick = (item: any) => {
    setState([item.selection]);
    setIsChanged(true)
    if (props.handleTableState) {
      props.handleTableState();
    }
    if (props.handleChange && !props.handleChangeOnClose) {
      let dates: filterDates = {
        startDate: item.selection.startDate,
        endDate: item.selection.endDate,
      };
      props.handleChange(dates);
    }
  };
  useEffect(() => {
    if (props.isNavbarSearchMode) {
      const newState = [
        {
          startDate: intialDatesForNavbarSearch.startDate,
          endDate: intialDatesForNavbarSearch.endDate,
          key: 'selection',
        },
      ];
      setState(newState);
    }
  }, [props.isNavbarSearchMode]);

  return (
    <Box>
      <SelectBoxButton>
        <Button
          className={state[0]['startDate'] ? 'selectedItems' : ''}
          aria-describedby={id}
          variant="contained"
          onClick={handleClick}
          endIcon={<ArrowDropDown />}
        >
          {`${props.label} ${format(state[0]['startDate'], timing.DATE)} to ${format(
            state[0]['endDate'],
            timing.DATE
          )}`}
        </Button>
      </SelectBoxButton>
      <DateRangePopover
        id={id}
        showCalender={open}
        anchorEl={anchorEl}
        state={state}
        handleClose={handleClose}
        onChange={handleChangeDatePick}
      />
    </Box>
  );
}
